import React, { Component } from 'react'
import hamburger from '../img/hamburger.svg'
import logo from '../img/logo.svg'

import { Link } from 'react-router-dom'

const SITES_WITH_MENU_TOP = ['/die_idee', '/unsere_gruppe', '/videos']

export default class Menu extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      bottom: !SITES_WITH_MENU_TOP.includes(this.props.location.pathname)
    }
  }

  openMenu () {
    this.setState({open: !this.state.open})
  }

  handleScrollEvent () {
    if (SITES_WITH_MENU_TOP.includes(this.props.location.pathname)) {
      if (this.state.bottom) {
        this.setState({bottom: false})
      }
    } else {
      let newBottom = window.scrollY + 83 <= window.innerHeight
      if (this.state.bottom !== newBottom) {
        this.setState({bottom: newBottom})
      }
    }
  }

  componentDidMount () {
    document.addEventListener('scroll', this.handleScrollEvent.bind(this))
  }

  componentDidUpdate (prevProps, prevState) {
    this.handleScrollEvent()
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.handleScrollEvent.bind(this))
  }

  render () {
    return <div id='menu' className={'menu' + (this.state.bottom && !this.props.plOpen ? ' menu--bottom' : '')}>
             <div className={'menu-container' + (this.state.open ? ' menu-container--extended' : '')}>
               <div className='menu-entry menu-title'>
                 <Link to='/#intro'>
                 <img className='menu-title-logo' src={logo} alt='Erinnerte Zukunft Logo' />
                 </Link>
               </div>
               <div className='menu-entry menu-hamburger' onClick={this.openMenu.bind(this)}>
                 <img className='menu-hamburger-image' src={hamburger} alt='Hamburger icon' />
               </div>
               <div className={'menu-entry menu-entry-container' + (!this.state.open ? ' menu-entry--hidden' : ' menu-entry--extended')}>
               <div className={'menu-entry-container-entry menu-videos'}>
                   <Link to='/videos'> Videos
                   </Link>
                 </div>
                 <div className={'menu-entry-container-entry menu-group'}>
                   <Link to='/unsere_gruppe'> Unsere Gruppe
                   </Link>
                 </div>
                 <div className={'menu-entry-container-entry menu-idea'}>
                   <Link to='/#idee'> Idee
                   </Link>
                 </div>
                 <div className={'menu-entry-container-entry menu-board'}>
                   <Link to='/#kuratorium'> Kuratorium
                   </Link>
                 </div>
                 <div className={'menu-entry-container-entry menu-material'}>
                   <Link to='/#material'> Material
                   </Link>
                 </div>
                 {/* <div className={'menu-entry-container-entry menu-imprint'}>
                   <Link to='/#impressum'> Impressum
                   </Link>
                 </div> */}
                 <div className={'menu-entry-container-entry menu-facebook'}>
                   <a href='https://www.facebook.com/Erinnerte-Zukunft-1570116896618337/' target='_blank' rel='noopener'>Facebook</a>
                 </div>
               </div>
             </div>
           </div>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/menu.js
 **/